// import { createSelector } from "@ngrx/store";

export const getFilter = state => state.filter;
export const getTypes = state => state.filter.types;
export const getCountry = state => state.filter.country;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/core/store/selectors/filter.selector.ts